import { FunctionComponent, useEffect, useRef, useState } from 'react';
import GenericIcons from './generics/GenericIcons';
import VdrWordmark from './brand/VdrWordmark';
import logoUaiCentra from '../img/logo-uai-centra.png';
import '../css/Footer.css';

const Footer: FunctionComponent = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [apply, setApply] = useState<boolean>(false);
  const [fontSize, setFontSize] = useState(16);

  /*
  NOTE: if the view is “Desktop”, the font of the <p> is calculated according to the width of the container, 
  but if the view is “Mobile” it is defined according to the css class.

  This is done this way, because the Footer in the PrivatePage is resized if the PrivateSidebar is open.
  */
  useEffect(() => {
    const container = containerRef.current;

    if (container) {
      const resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          const contenedorWidth = entry.contentRect.width;
          const newFontSize = contenedorWidth * 0.01;
          setFontSize(newFontSize);
        }
      });

      resizeObserver.observe(container);

      return () => {
        resizeObserver.unobserve(container);
      };
    }
  }, []);

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      const computedStyle = window.getComputedStyle(container);
      if (computedStyle.flexDirection === 'row') {
        setApply(true);
      } else {
        setApply(false);
      }
    }
  }, [fontSize]);

  // Tamaños acotados: el ancho del contenedor manda, pero sin bajar de lo legible.
  return (
    <div className='footer-container'>
      <div className='footer-logos' ref={containerRef}>
        <div className='vdr-foot-partners'>
          <GenericIcons icon='LogoANID' className='vdr-foot-logo vdr-foot-logo-anid' />
          <GenericIcons icon='LogoACESOL' className='vdr-foot-logo vdr-foot-logo-acesol' />
          <img
            className='vdr-foot-logo vdr-foot-logo-uai'
            src={logoUaiCentra}
            alt='Universidad Adolfo Ibáñez · CENTRA'
          />
        </div>
        <div className='footer-support-info'>
          <p
            className='footer-support-info-14'
            style={apply ? { fontSize: `clamp(11px, ${fontSize}px, 12px)` } : undefined}>
            FACULTAD DE INGENIERÍA Y CIENCIAS
          </p>
          <p
            className='footer-support-info-12'
            style={apply ? { fontSize: `clamp(13.5px, ${fontSize}px, 15px)` } : undefined}>
            SANTIAGO - (56 2) 2331 1000
          </p>
          <p
            className='footer-support-info-12'
            style={apply ? { fontSize: `clamp(13.5px, ${fontSize}px, 15px)` } : undefined}>
            Diagonal las Torres 2640, Peñalolén.
          </p>
        </div>
      </div>
      <div className='footer-created-by'>
        <VdrWordmark onDark size='sm' className='vdr-foot-wordmark' />
      </div>
    </div>
  );
};

export default Footer;
